import { Component, computed, inject, ChangeDetectionStrategy, input } from '@angular/core';
import { UIService } from '@shared/utils';
import packageInfo from '@root/package.json';

import { WrapperComponent } from '@shared/ui/components';
import { ContentWidthService } from '../../services/content-width.service';

@Component({
  selector: 'reza-footer',
  imports: [WrapperComponent],
  // patička podle gov.cz (vzor AISK): barvy z tokenů --component-footer-*, obsah v kontejneru ui-wrapper zarovnaný
  // s obsahem stránky
  host: {
    class: 'block py-6 bg-(--component-footer-background) text-(--component-footer-text-primary) text-[96%]',
  },
  template: `
    <ui-wrapper class="flex flex-wrap justify-between items-center gap-4">
      <div class="flex flex-col items-start">
        @if (publicFooter()) {
          <span>
            {{ currentYear }} © DIA • Informace jsou poskytovány v souladu se zákonem č. 106/1999 Sb., o svobodném
            přístupu k informacím.
          </span>
        }
        <a href="https://www.dia.gov.cz/" class="underline text-(--component-footer-text-link)">
          Digitální a informační agentura - Startujeme digitalizaci Česka | Digitální Transformace (gov.cz)
        </a>
      </div>
      <!-- easter egg: 3 kliknutí odemknou panel šířky obsahu (ContentWidthService); záměrně jen myší -->
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <span (click)="contentWidth.versionClick()">Verze: {{ version() }}</span>
    </ui-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FooterComponent {
  readonly publicFooter = input(false);

  readonly uiService = inject(UIService);
  protected readonly contentWidth = inject(ContentWidthService);
  currentYear = new Date().getFullYear();

  readonly version = computed(() => {
    if (this.uiService.isProdEnv) {
      return this.getProductionVersion(packageInfo.version);
    } else {
      return packageInfo.version;
    }
  });

  private getProductionVersion(version: string): string {
    // Rozdělení verze na části pomocí tečky a pomlčky
    const parts = version.split(/[.-]/);

    // Vrácení prvních dvou částí (major a minor verze)
    return `${parts[0]}.${parts[1]}`;
  }
}
